"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EMPLOYMENT_STATUS = void 0;
var EMPLOYMENT_STATUS = {
  employed: {
    value: 'EMPLOYED',
    label: 'Employed'
  },
  unemployed: {
    value: 'UNEMPLOYED',
    label: 'Unemployed'
  },
  retired: {
    value: 'RETIRED',
    label: 'Retired'
  }
};
exports.EMPLOYMENT_STATUS = EMPLOYMENT_STATUS;
